import React, { useState, useContext, useEffect, useRef, useMemo, useCallback } from "react";
import { IoMenu, IoClose } from "react-icons/io5";
import { FaUser, FaSignOutAlt, FaSearch, FaShoppingCart, FaMapMarkerAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import { getMyAccountId, isBMI, BMI_CUSTOMER_IDS } from "../../utils/config";
import { CartContext } from "../../context/CartContext";
import SearchBar from "../UI/SearchBar";
import { useHistory, useLocation } from "react-router-dom";
import { getLogoUrl } from "../../utils/config";
import { getUserPhotoUrl } from "../../utils/config";
import { getAsesorPhotoUrl } from "../../utils/config";
import { FaWhatsapp } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext";
import { useImageViewer } from "../../context/ImageViewerContext";
import { API_BASE } from "../../utils/api";
import CustomerSearchModal from "../../components/Modals/CustomerSearchModal";
import BranchSelector from "../../components/Modals/BranchSelector";
import Ext1CustomerSelector from "../../components/Modals/Ext1CustomerSelector";
import { useRidePreview } from "../../hooks/useRidePreview";
import RidePreviewModal from "../../components/Modals/RidePreviewModal";
import { fetchSalesman } from "../../utils/fetchSalesman";
export default function TopbarFinal({
  keyword,
  setKeyword,
  onSearch,
  loading
}) {
  const MYACCOUNT_ID = getMyAccountId();
  const [open, setOpen] = useState(false);
  const toggleMenu = () => setOpen(!open);
  const { user, login, logout, updateSelectedCustomer } = useContext(UserContext);
  const isSupervisor = user?.groupId === "     9";
  const isAdvisor = user?.groupId === "     1";
  const { cartCount, openCart } = useContext(CartContext);
  const [logoExists, setLogoExists] = useState(true);
  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const [localKeyword, setLocalKeyword] = useState("");
  const history = useHistory();
  const location = useLocation();
  const [hasPhoto, setHasPhoto] = useState(true);
  const userPhotoUrl = useMemo(
    () => (user ? getUserPhotoUrl(user.userId, true) : null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user?.userId]
  );

  useEffect(() => {
    setHasPhoto(true);
  }, [user?.userId]);
  const { t, switchLanguage, language } = useLanguage();
  const { openImage } = useImageViewer();
  // const hasRealPhoto = Boolean(user?.idSalesman);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [showExt1Selector, setShowExt1Selector] = useState(false);
  const [hasRealPhoto, setHasRealPhoto] = useState(false);
  const [salesman, setSalesman] = useState(() => JSON.parse(localStorage.getItem("salesman")));

  const asesorPhotoUrl = useMemo(
    () => getAsesorPhotoUrl(salesman?.idSalesman ?? "default", true),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [salesman?.idSalesman]
  );

  const logoUrl = useMemo(
    () => (user?.cedula ? getLogoUrl(user.cedula, true) : null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user?.cedula]
  );

  // 👈 NUEVOS ESTADOS PARA EL MODAL DE SUCURSAL
  const [showBranchModal, setShowBranchModal] = useState(false);
  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);
  const [loadingBranches, setLoadingBranches] = useState(false);
  const { clearCart, closeCart } = useContext(CartContext);
  const { rideOpen, rideUrl, openRidePreview, closeRidePreview } = useRidePreview();

  const fetchBranches = async () => {
    setLoadingBranches(true);
    try {
      const response = await fetch(`${API_BASE}/api-ultra/api/ws/getBranches?myaccount_id=${MYACCOUNT_ID}`);
      const data = await response.json();
      setBranches(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Error cargando sucursales:", error);
      setBranches([]);
    } finally {
      setLoadingBranches(false);
    }
  };

  // 👈 FUNCIÓN PARA ABRIR EL MODAL DE SUCURSAL
  const openBranchSelector = async () => {
    setShowBranchModal(true); // Abrir modal primero (muestra loading)
    await fetchBranches();    // Luego cargar datos
  };


  // 👈 FUNCIÓN PARA CONFIRMAR SUCURSAL SELECCIONADA
  const handleConfirmBranch = async () => {
    if (selectedBranch) {
      // selectedBranch es el objeto completo con bodegaId, bodegaName, etc.
      const updatedUser = {
        ...user,
        bodegaId: selectedBranch.bodegaId,
        bodegaName: selectedBranch.bodegaName,
        idCustomer: null,
        companyName: null,
        customerId: null,
        nameShipTo: null,
        cedula: null,
      };
      clearCart();
      localStorage.removeItem("order_express_items");
      localStorage.removeItem("checkout_payload");
      login(updatedUser);
      setShowBranchModal(false);
      setSelectedBranch(null); // Limpiar selección

      // Recargar para aplicar cambios
      history.push("/dashboard");
      window.location.reload()
    }
  };

  // 👈 FUNCIÓN PARA CERRAR MODAL
  const handleCloseBranchModal = () => {
    setShowBranchModal(false);
    setSelectedBranch(null);  //
  };

  const handleExt1Select = (customer) => {
    clearCart();
    localStorage.removeItem("order_express_items");
    localStorage.removeItem("checkout_payload");
    sessionStorage.removeItem("frequent_products_page");
    updateSelectedCustomer(customer);
  };


  useEffect(() => {
    function handleClickOutside(e) {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setUserMenuOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const [isProformaMode, setIsProformaMode] = useState(
    () => localStorage.getItem("order_mode") === "proforma"
  );
  useEffect(() => {
    const sync = () => setIsProformaMode(localStorage.getItem("order_mode") === "proforma");
    window.addEventListener("orderModeChange", sync);
    return () => window.removeEventListener("orderModeChange", sync);
  }, []);
  useEffect(() => {
    const sync = () => setSalesman(JSON.parse(localStorage.getItem("salesman")));
    window.addEventListener("salesman-updated", sync);
    return () => window.removeEventListener("salesman-updated", sync);
  }, []);

  useEffect(() => {
    if (!user?.idSalesman) return;
    if (user.sw1 && user.idCustomer) return;
    fetchSalesman(user.idSalesman).then((data) => {
      if (!data) return;
      localStorage.setItem("salesman", JSON.stringify(data));
      setSalesman(data);
    }).catch(() => {});
  }, [user?.idSalesman]);

  // Contador de ordenes pendientes de aprobacion, para el badge en el menu de usuario.
  const [pendingApprovalCount, setPendingApprovalCount] = useState(null);
  const loadPendingApprovalCount = useCallback(() => {
    if ((!isSupervisor && !isAdvisor) || !user?.idCustomer) {
      setPendingApprovalCount(null);
      return;
    }
    const buildParams = (idCustomer) => {
      const params = new URLSearchParams();
      params.append("id_customer", idCustomer);
      // El Aprobador siempre ve TODAS las sucursales aqui (no se manda id_ship_to,
      // el backend lo recibe NULL), sin importar en que sucursal haya quedado
      // parada su sesion — no puede cambiar de sucursal, se le muestra todo de una.
      // El Asesor si respeta su sucursal actual.
      if (!isSupervisor && Number(user.idShipTo)) {
        params.append("id_ship_to", Number(user.idShipTo));
      }
      params.append("myaccount_id", MYACCOUNT_ID);
      params.append("clase", "+");
      params.append("tipo", "PE");
      return params;
    };

    // El Aprobador de una marca BMI ve pendientes de ambas cuentas (UIO+GYE), no
    // solo la de su propia sesion — igual que en Mantenimiento de Presupuestos.
    const idCustomers = isSupervisor && isBMI(user) ? BMI_CUSTOMER_IDS : [user.idCustomer];

    Promise.all(
      idCustomers.map((idCustomer) =>
        fetch(`${API_BASE}/orders-ultra/api/ws/list_orders_ecommerce?${buildParams(idCustomer).toString()}`)
          .then((r) => r.json())
          .then((d) => (Array.isArray(d) ? d : []))
      )
    )
      .then((results) => setPendingApprovalCount(results.flat().length))
      .catch(() => setPendingApprovalCount(null));
  }, [isSupervisor, isAdvisor, user?.idCustomer, user?.idShipTo, MYACCOUNT_ID]);

  useEffect(() => {
    loadPendingApprovalCount();
    window.addEventListener("pending-approval-updated", loadPendingApprovalCount);
    return () => window.removeEventListener("pending-approval-updated", loadPendingApprovalCount);
  }, [loadPendingApprovalCount]);

  // Sincronizar la barra de búsqueda: mostrar término activo o limpiar al salir de /categoria
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const term = params.get("search");
    if (term) {
      setLocalKeyword(term);
    } else {
      setLocalKeyword("");
    }
  }, [location.pathname, location.search]);

  const triggerSearch = () => {
    if (!localKeyword.trim()) return;
    history.push(`/categoria/all?search=${encodeURIComponent(localKeyword.trim())}`);
  };


  return (

    <div
      className={`
        relative z-50 w-full text-white shadow-md bg-brand-primary -mt-2
        ${user ? `
          md:bg-[linear-gradient(to_right,var(--color-primary)_0%,var(--color-primary)_90%,#ffffff_90%,#ffffff_100%)]
          lg:bg-[linear-gradient(to_right,var(--color-primary)_0%,var(--color-primary)_80%,#ffffff_80%,#ffffff_100%)]
          xl:bg-[linear-gradient(to_right,var(--color-primary)_0%,var(--color-primary)_70%,#ffffff_70%,#ffffff_100%)]
        ` : ""}
      `}

    >


      {/* ███ TOPBAR DELGADO - Mantenemos todas tus opciones ███ */}
      <div className="hidden container mx-auto px-4 py-1 flex justify-center text-sm -ml-2">
        <div className="hidden lg:flex gap-6">
          {!user && (
            <>
              <a className="hidden hover:text-gray-300 cursor-pointer">Find a Store</a>
              <Link
                to="/register"
                className="hidden hover:text-gray-300 cursor-pointer"
              >
                Registre su Empresa
              </Link>
              <a className="hover:text-gray-300 cursor-pointer">Contáctenos</a>
              <a className="hover:text-gray-300 cursor-pointer">Acerca de nosotros</a>
            </>
          )}
        </div>
        <button onClick={toggleMenu} className="lg:hidden text-2xl">
          {open ? <IoClose /> : <IoMenu />}
        </button>
      </div>

      {/* ███ MENÚ MÓVIL (Opción C) - Todo igual ███ */}
      {open && (
        <div className="lg:hidden fixed top-[56px] left-0 w-full z-[99999] bg-brand-primary px-4 pb-6 text-sm text-white shadow-xl">
          <div className="flex flex-col gap-4 mt-2">
            {!user && (
              <>
                <a className="cursor-pointer transition hover:text-gray-300">Find a Store</a>
                <a className="cursor-pointer transition hover:text-gray-300">Become a Member</a>
                <a className="cursor-pointer transition hover:text-gray-300">Contact Us</a>
                <a className="cursor-pointer transition hover:text-gray-300">About Us</a>
              </>
            )}
            <hr className="border-gray-200 my-2" />
            {user && (
              <>
                <Link to="/dashboard" onClick={() => setOpen(false)} className="transition hover:text-gray-300">My Dashboard</Link>
                <Link to="/profile" onClick={() => setOpen(false)} className="transition hover:text-gray-300">My Account</Link>
                <button
                  onClick={() => {
                    logout();
                    window.location.href = "/login";
                  }}
                  className="text-left font-semibold text-white hover:text-gray-300 transition flex items-center gap-2"
                >
                  <FaSignOutAlt /> Cerrar Sesión
                </button>
              </>
            )}
            {!user && (
              <Link to="/login" onClick={() => setOpen(false)} className="font-semibold transition hover:text-gray-300">Iniciar Sesión</Link>
            )}
          </div>
        </div>
      )}




      {/* ███ ZONA PRINCIPAL ███ */}

      <div className="container mx-auto px-2 relative min-h-[110px] flex items-center overflow-visible -mt-2">


        {/* LOGO + SUCURSAL */}
        <div className="flex flex-col items-center z-10
                absolute left-1/2 -translate-x-1/2
                md:static md:translate-x-0">

          <Link to="/" onClick={() => { setLocalKeyword(""); }} >
            <div className="h-24 lg:h-32 flex items-center -mt-0 -mb-6 -ml-8">
              <img
                src={`https://www.ultra-erp.pro/logos/${MYACCOUNT_ID}.png`}
                alt={"LOGO-" + MYACCOUNT_ID}
                className="
               relative
                w-[300px]
                h-auto
                flex
                items-center
                justify-center
                rounded-lg
                overflow-hidden
              "
              />

            </div>
          </Link>

          {/* 👈 SUCURSAL CLICKEABLE */}
          <p
            onClick={() => {
              if (user && user.changeBranch) {
                openBranchSelector();
              }
            }}
            className={`
            text-white text-sm lg:text-xl -mt-2
            ${user && user.changeBranch ? "visible cursor-pointer hover:underline" : user && !user.changeBranch ? "visible" : "invisible mt-0"}
            z-[99999] relative
          `}
          >

            Sucursal: {user?.bodegaName || "—"}
          </p>
        </div>
        {user && salesman && (
          <div className="flex items-center gap-3 mt-1 ml-0 z-[99]">
            {/* FOTO ASESOR */}
            <button
              type="button"
              onClick={() => {
                if (salesman?.idSalesman === "default" || !salesman?.idSalesman) return;
                openImage(asesorPhotoUrl);
              }}
              className={`
              w-10 h-10 lg:w-14 lg:h-14
              rounded-full
              overflow-hidden
              bg-gray-100
              shadow-sm
              transition
              hover:scale-110 cursor-pointer
            `}
            >
              <img
                key={salesman?.idSalesman ?? "default"}
                src={asesorPhotoUrl}
                alt="Asesor"
                onError={(e) => {
                  e.currentTarget.onerror = null;
                  e.currentTarget.src = getAsesorPhotoUrl("default", true);
                }}
                className="w-full h-full object-cover rounded-full"
              />
            </button>



            {/* INFO */}
            <div className="leading-tight uppercase -ml-2">
              <p className="text-white text-xs lg:text-sm font-semibold">
                Asesor: {salesman.nameSalesman}
              </p>
              <div className="flex items-center gap-2">
                <p className="text-white/80 text-[14px] lg:text-sm">
                  {salesman.phone}
                </p>

                <a
                  href={`https://wa.me/593${salesman.phone}`}
                  target="_blank"
                  rel="noreferrer"
                  className="text-green-400 hover:text-green-300 transition"
                  title="Contactar por WhatsApp"
                >
                  <FaWhatsapp className="w-4 h-4 lg:w-5 lg:h-5" />
                </a>
              </div>
            </div>
          </div>
        )}




        {/* 3. PANEL USUARIO: Anclado a la derecha sin mover el resto */}
        <div
          className={`
          hidden md:flex absolute right-0 top-0 h-full z-5 -mr-10
        `}
        >
          <div
            className={`
            flex items-center gap-2 -mt-2
            px-4 lg:px-4 py-7 font-[500]
            rounded-xl 
            ${user ? "bg-white shadow-md" : ""}
          `}
          >



            {user ? (
              <div className="flex items-center gap-1 w-full mt-2">
                {/* LOGO EMPRESA */}
                <div className="min-w-[110px] min-h-[65px] max-w-[110px] max-h-[65px] flex items-center justify-center">
                  {logoExists && logoUrl && (
                    <img
                      src={logoUrl}
                      alt="Logo Empresa"
                      onError={() => setLogoExists(false)}
                      onClick={() => openImage(logoUrl)}
                      className="
                      w-full h-full
                      object-contain
                      opacity-90
                      cursor-pointer
                      transition hover:scale-105
                    "
                    />
                  )}
                </div>



                {/* INFO */}
                <div className="flex flex-col flex-1 text-right pr-4 leading-tight border-r border-gray-300/40 max-w-[330px] w-full">
                  <span className="hidden text-sm text-brand-primary tracking-wider uppercase text-right">
                    Bienvenido a su portal de
                  </span>

                  {user?.valorExt1 > -1 || user?.hasCustShipTo === true ? (
                    user?.idCustomer ? (
                      <span
                        onClick={() => setShowExt1Selector(true)}
                        className="text-sx text-gray-900 line-clamp-2 text-right min-w-[250px] max-w-[250px] cursor-pointer hover:text-brand-primary"
                      >
                        {user?.companyName}
                      </span>
                    ) : (
                      <span
                        onClick={() => setShowExt1Selector(true)}
                        className="text-sx line-clamp-2 text-right min-w-[250px] max-w-[250px] cursor-pointer text-brand-primary font-semibold italic"
                      >
                        ...
                      </span>
                    )
                  ) : user?.changeCustomer && !user?.idCustomer ? (
                    <span
                      onClick={() => setShowCustomerModal(true)}
                      className="text-sx line-clamp-2 text-right min-w-[250px] max-w-[250px] cursor-pointer text-brand-primary font-semibold italic"
                    >
                      Seleccionar Cliente...
                    </span>
                  ) : (
                    <span
                      onClick={() => user?.changeCustomer && setShowCustomerModal(true)}
                      className={`text-sx text-gray-900 line-clamp-2 text-right min-w-[250px] max-w-[250px] ${user?.changeCustomer ? "cursor-pointer hover:text-brand-primary" : ""}`}
                    >
                      {user?.companyName}
                    </span>
                  )}

                  {user?.nameShipTo && (
                    <span className="text-sx text-gray-700 truncate text-right flex items-center justify-end gap-1">
                      <FaMapMarkerAlt className="text-brand-primary text-xs flex-shrink-0" />
                      <strong className="truncate">{user.nameShipTo}</strong>
                    </span>
                  )}

                  <span className="mt-2 text-sx text-gray-800 truncate text-right">
                    Hola,{" "}
                    <span className=" capitalize">
                      {user.firstName.toLowerCase()}
                    </span>
                  </span>
                  {isProformaMode && (
                    <span className="text-xs font-semibold text-brand-primary tracking-wide uppercase text-right">
                      Solicitud de Proforma
                    </span>
                  )}
                </div>


                {/* CARRITO */}
                <button onClick={openCart} className="relative bg-gray-100 hover:bg-gray-200 text-brand-primary w-14 h-14 rounded-xl flex items-center justify-center shadow-sm transition hover:scale-105 cursor-pointer">
                  <FaShoppingCart className="text-xl" />
                  <span className="absolute -top-1 -right-1 bg-brand-primary text-white text-xs w-5 h-5 flex items-center justify-center rounded-full">
                    {cartCount}
                  </span>
                </button>

                {/* BOTÓN DESPLEGABLE */}
                <div className="relative" ref={menuRef}>

                  <button
                    onClick={() => setUserMenuOpen(!userMenuOpen)}
                    className="w-14 h-14 rounded-full bg-gray-100 flex items-center justify-center shadow-sm transition hover:scale-105 overflow-hidden"
                  >
                    {userPhotoUrl && hasPhoto ? (
                      <img
                        src={userPhotoUrl}
                        alt="Usuario"
                        className="w-full h-full object-cover rounded-full"
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          setHasPhoto(false);
                        }}
                      />
                    ) : (
                      <FaUser className="text-brand-primary text-xl" />
                    )}
                  </button>



                  {userMenuOpen && (
                    <div className="absolute right-0 mt-2 w-56 bg-white rounded-xl shadow-xl border border-gray-200 z-[100]">
                      {userPhotoUrl && hasPhoto && (
                        <>
                          <button
                            onClick={() => {
                              openImage(userPhotoUrl);
                              setUserMenuOpen(false);
                            }}
                            className="w-full text-left px-4 py-3 text-sm text-gray-700 hover:bg-gray-100"
                          >
                            Ver imagen
                          </button>
                          <div className="border-t my-1"></div>
                        </>
                      )}

                      {(() => {
                        const noCustomer = !user?.idCustomer;
                        const disabledClass = "pointer-events-none text-gray-400";
                        const enabledClass = "text-gray-700 hover:bg-gray-100";
                        const itemClass = (extra = "") =>
                          `block px-4 py-3 text-sm ${noCustomer ? disabledClass : enabledClass} ${extra}`;
                        return (
                          <>
                            <Link to="/dashboard" onClick={() => setUserMenuOpen(false)} className={itemClass()}>{t.menuDashboard}</Link>
                            <Link to="/profile" onClick={() => setUserMenuOpen(false)} className={itemClass()}>{t.menuMyAccount}</Link>
                            <Link to="/order-express" onClick={() => setUserMenuOpen(false)} className={itemClass("hidden")}>{t.menuQuickOrder}</Link>
                            <Link to="/orders-history" onClick={() => setUserMenuOpen(false)} className={itemClass()}>{t.menuOrderHistory}</Link>
                            {(isSupervisor || isAdvisor) && (
                                <Link
                                    to={{ pathname: "/orders-history", state: { activeTab: "pending_approval" } }}
                                    onClick={() => setUserMenuOpen(false)}
                                    className={`${itemClass()} flex items-center justify-between gap-2`}
                                >
                                    <span>Pendientes de Aprobación</span>
                                    {pendingApprovalCount > 0 && (
                                        <span className="inline-flex items-center justify-center min-w-[20px] h-[20px] px-1.5 rounded-full text-xs font-bold bg-brand-primary text-white flex-shrink-0">
                                            {pendingApprovalCount > 99 ? "99+" : pendingApprovalCount}
                                        </span>
                                    )}
                                </Link>
                            )}
                            <div className="border-t my-1"></div>
                            <Link to="/orders-cxp" onClick={() => setUserMenuOpen(false)} className={itemClass()}>{t.menuCxP}</Link>
                            <Link to="/orders-review?doc_elect_sri=true" onClick={() => setUserMenuOpen(false)} className={itemClass("hidden")}>{t.menuDocumentsReceived}</Link>
                            <Link to="/orders-review?doc_elect_sri=false" onClick={() => setUserMenuOpen(false)} className={itemClass()}>{t.menuOthersDocumentsReceived}</Link>
                            <button
                              disabled={noCustomer}
                              onClick={() => {
                                const reportUrl = `${API_BASE}/orders-ultra/api/reports_general/prices_negociados_by` +
                                  `?myaccount_id=${user.myaccountId}` +
                                  `&company_id=${user.companyId}` +
                                  `&id_customer=${user.idCustomer}` +
                                  `&user=${user.userId}`;
                                openRidePreview(reportUrl);
                              }}
                              className={`w-full text-left px-4 py-3 text-sm ${noCustomer ? "text-gray-400 cursor-not-allowed" : "text-gray-700 hover:bg-gray-100"}`}
                            >
                              Lista de Precios Negociados
                            </button>
                          </>
                        );
                      })()}
                      <div className="border-t my-1"></div>
                      <button
                        onClick={() => {
                          logout();
                          window.location.href = "/login";
                        }}
                        className="w-full text-left px-4 py-3 text-brand-primary font-bold hover:bg-red-50 flex items-center gap-2"
                      >
                        <FaSignOutAlt /> Cerrar Sesión
                      </button>
                    </div>
                  )}
                </div>
              </div>
            ) : (
              /* ICONO DE USUARIO CUANDO NO HAY SESIÓN */
              <Link
                to="/login"
                className="bg-brand-primary text-3xl text-white p-2 hover:scale-110 transition"
              >
                <FaUser />
              </Link>
            )}
          </div>
        </div>
        {/* BUSCADOR DESKTOP */}
        <div className={`hidden md:flex absolute left-1/2   ${user ? "top-16 " : ""} transform -translate-x-1/2 w-full max-w-sm z-50`}>

          <SearchBar
            className="h-9 text-sm"
            placeholder="Buscar productos…"
            value={localKeyword}
            onChange={(e) => setLocalKeyword(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                triggerSearch();
              }
            }}
            onSearch={triggerSearch}
          />
        </div>
        {/* Agregar al final del componente TopbarFinal */}
        {showCustomerModal && (
          <CustomerSearchModal
            open={showCustomerModal}
            onClose={() => setShowCustomerModal(false)}
            onSelect={updateSelectedCustomer}
          />
        )}
        {showBranchModal && (
          <BranchSelector
            branches={branches}
            selectedBranch={selectedBranch}        // 👈 Cambiado
            setSelectedBranch={setSelectedBranch}  // 👈 Cambiado
            onConfirm={handleConfirmBranch}
            onClose={handleCloseBranchModal}
            loading={loadingBranches}
          />
        )}
        <Ext1CustomerSelector
          open={showExt1Selector}
          onSelect={handleExt1Select}
          onClose={() => setShowExt1Selector(false)}
        />
        <RidePreviewModal open={rideOpen} url={rideUrl} onClose={closeRidePreview} />
      </div>
    </div >
  );
}